<template>
  <VButton :size="size" :no-shadow="noShadow" :no-border="noBorder" :variant="variant" data-testid="meeting-link-copy-btn" @click="copy">
    <template v-if="wasClicked">
      <CheckIcon class="inline-block w-5 mr-2" />
      Copied!
    </template>
    <template v-else><slot /></template>
  </VButton>
</template>

<script lang="ts" setup>
import { CheckIcon } from '@heroicons/vue/24/solid'

const props = defineProps({
  copyText: {
    type: String,
    required: true,
  },
  size: {
    type: String,
    default: 'md',
  },
  noShadow: {
    type: [Boolean, String],
    default: false,
  },
  noBorder: {
    type: [Boolean, String],
    default: false,
  },
  variant: {
    type: String,
    default: 'light',
  },
})

const emit = defineEmits(['click'])

const { wasClicked, copyToClipboard } = useCopyToClipboard()

function copy() {
  copyToClipboard({
    copyText: props.copyText,
  })
  emit('click')
}
</script>
